import { render, staticRenderFns } from "./CreateRider.vue?vue&type=template&id=34362b79"
import script from "./CreateRider.vue?vue&type=script&lang=js"
export * from "./CreateRider.vue?vue&type=script&lang=js"
import style0 from "./CreateRider.vue?vue&type=style&index=0&id=34362b79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports